import { ListItem, ListItemText, styled } from '@mui/material';
import clsx from 'clsx';
import { NavLink } from 'react-router';

import type { MenuLink } from '../../menu-items.tsx';

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '& > span': {
    fontSize: '1.125rem',
    fontWeight: theme.typography.fontWeightSemiBold,
  },
}));

interface NavItemProps {
  menuItem: MenuLink;
  onClick?: any;
}

const NavItem = ({ menuItem, onClick, ...rest }: NavItemProps) => {
  const { title, href } = menuItem;

  return (
    <ListItemLink
      to={href}
      {...rest}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      <StyledListItemText>{title}</StyledListItemText>
    </ListItemLink>
  );
};

export default NavItem;

const ListItemLink = ({ ...props }) => {
  return (
    <ListItem
      disableGutters
      component={({ className, ...linkProps }: any) => (
        <NavLink
          prefetch="intent"
          className={({ isActive }) => clsx(className, isActive && 'active')}
          sx={{ '&.active': { color: 'primary.main' } }}
          {...linkProps}
        />
      )}
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        padding: '12px 64px',
        width: '100%',
      }}
      {...props}
    />
  );
};
